import { cn } from '@/src/helpers';
import { FC, HTMLAttributes } from 'react';
import { Flex } from '../../flex';
import { tradingSectionClasses } from '../trading-section.constants';

type TradingSectionHeaderProps = HTMLAttributes<HTMLHeadingElement>;

/**
 * Child component for Page that renders a title, as well as optional action and children.
 * @param {Object} props Component props
 * @param {boolean} [props.borderless] Optional boolean to hide the bottom border. Useful for pages that have tab navigation below the title.
 * @returns PageHeader content
 */
export const TradingSectionHeader: FC<TradingSectionHeaderProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <Flex
      as="header"
      wrap="wrap"
      align="center"
      justify="between"
      className={cn(tradingSectionClasses.header, 'mb-0 px-3 py-3 gap-x-2 gap-y-5 items-center', className)}
      {...rest}
    >
      {children}
    </Flex>
  );
};
